export const SET_STRIPE = "SET_STRIPE";

export const setStripe = (payload) => ({payload, type: SET_STRIPE});
